import { gql } from '@apollo/client';

const QUERY_SINGLE_PEDAGOGICAL_CHALLENGE = gql`
  query SingleDefi($id: ID!) {
    getDefiById(id: $id) {
      name
      debut
      fin
      reglement {
        ... on ComponentDefiReglement {
          title
          text
        }
      }
      ressources {
        ... on ComponentDefiDefiLiens {
          name
          url
        }
        ... on ComponentDefiDefiMedia {
          name
          media {
            data {
              attributes {
                alternativeText
                url
              }
            }
          }
        }
      }
      recompenses {
        category
        lots
        recompenses_winners {
          data {
            id
            attributes {
              username
              classes {
                data {
                  attributes {
                    lycee {
                      data {
                        attributes {
                          name
                        }
                      }
                    }
                  }
                }
              }
              avatar {
                data {
                  attributes {
                    media {
                      data {
                        attributes {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default QUERY_SINGLE_PEDAGOGICAL_CHALLENGE;
